var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToolIcon6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 103,
    viewBox: "0 0 102 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 103,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5312 49.8354H32.5312V56.165H34.5312V49.8354Z",
    fill: "#057EE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2266 49.8354H39.2266V56.165H41.2266V49.8354Z",
    fill: "#057EE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9219 49.8354H45.9219V56.165H47.9219V49.8354Z",
    fill: "#057EE6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2871 52H58.2891V54H61.2871V52Z",
    fill: "#111733"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4678 52H65.4688V54H68.4678V52Z",
    fill: "#111733"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5312 34.502H32.5312V40.8315H34.5312V34.502Z",
    fill: "#057EE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2266 34.502H39.2266V40.8315H41.2266V34.502Z",
    fill: "#057EE6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9219 34.502H45.9219V40.8315H47.9219V34.502Z",
    fill: "#057EE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2871 36.667H58.2891V38.667H61.2871V36.667Z",
    fill: "#111733"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4678 36.667H65.4688V38.667H68.4678V36.667Z",
    fill: "#111733"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0059 77H70.9941C73.2031 77 75 75.2031 75 72.9946V63.6724C75 62.4694 74.4561 61.4014 73.614 60.6665C74.4561 59.9316 75 58.8638 75 57.6611V48.3389C75 47.1362 74.4561 46.0683 73.614 45.3334C74.4561 44.5986 75 43.5306 75 42.3276V33.0054C75 30.7969 73.2031 29 70.9941 29H31.0059C28.7969 29 27 30.7969 27 33.0054V42.3276C27 43.5306 27.5439 44.5986 28.386 45.3334C27.5439 46.0683 27 47.1362 27 48.3389V57.6611C27 58.8638 27.5439 59.9316 28.386 60.6665C27.5439 61.4014 27 62.4694 27 63.6724V72.9946C27 75.2031 28.7969 77 31.0059 77ZM29 33.0054C29 31.8994 29.8994 31 31.0059 31H70.9941C72.1006 31 73 31.8994 73 33.0054V42.3276C73 43.4336 72.1006 44.3335 70.9941 44.3335H31.0059C29.8994 44.3335 29 43.4336 29 42.3276V33.0054ZM29 48.3389C29 47.2329 29.8994 46.3335 31.0059 46.3335H70.9941C72.1006 46.3335 73 47.2329 73 48.3389V57.6611C73 58.7671 72.1006 59.6665 70.9941 59.6665H31.0059C29.8994 59.6665 29 58.7671 29 57.6611V48.3389ZM29 63.6724C29 62.5664 29.8994 61.6665 31.0059 61.6665H70.9941C72.1006 61.6665 73 62.5664 73 63.6724V72.9946C73 74.1006 72.1006 75 70.9941 75H31.0059C29.8994 75 29 74.1006 29 72.9946V63.6724Z",
    fill: "#111733"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5312 65.1689H32.5312V71.498H34.5312V65.1689Z",
    fill: "#057EE6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2266 65.1689H39.2266V71.498H41.2266V65.1689Z",
    fill: "#057EE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9219 65.1689H45.9219V71.498H47.9219V65.1689Z",
    fill: "#057EE6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2871 67.3335H58.2891V69.3335H61.2871V67.3335Z",
    fill: "#111733"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M68.4678 67.3335H65.4688V69.3335H68.4678V67.3335Z",
    fill: "#111733"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolIcon6);
export default __webpack_public_path__ + "static/media/tool-icon-6.04f1a367e27fcbb9a1a4dae433724728.svg";
export { ForwardRef as ReactComponent };